import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BackToTopButton } from 'src/components/molecules/BackToTopButton/BackToTopButton';
import { ProductListError } from 'src/components/molecules/ProductListError/ProductListError';
import { ListingsControlsDrawerContainer } from 'src/components/organisms/ListingsControlsDrawer/ListingsControlsDrawerContainer';
import { useFilterNavType } from 'src/hooks/useFilterNavType/useFilterNavType';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as navigationActions } from 'src/redux/navigation/slice';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import * as styles from 'src/styles/pages.styles';
import { ListingsLayout } from '../../layouts/ListingLayout/ListingsLayout';

export const PartnerListing = ({ stickyTopBanner = false }: { stickyTopBanner?: boolean }) => {
  const dispatch = useDispatch();

  const products = useSelector((state: ReduxApplicationState) => state.products);
  const totalProducts = useSelector(selectTotalProducts);
  const activeFacetsCount = useSelector(
    (state: ReduxApplicationState) => selectActiveFacets(state).length,
  );
  const showProductsList = !products.error && (totalProducts > 0 || activeFacetsCount > 0);

  useFilterNavType((navType) => dispatch(navigationActions.setInitialPageLoad(navType)));

  return (
    <div css={styles.wrapper}>
      {showProductsList ? (
        <ListingsLayout separatingLine={false} stickyTopBanner={stickyTopBanner}>
          <BackToTopButton />
          <ListingsControlsDrawerContainer />
        </ListingsLayout>
      ) : (
        <ProductListError message={products.error ? products.error.message : 'No products found'} />
      )}
    </div>
  );
};
